import React from 'react';
import type { ViewStyle } from 'react-native';
import { ProfileImg } from './ProfileImg';

type Profile = {
  first_name?: string;
  last_name?: string;
  photos?: {
    thumbnail_small?: string;
    thumbnail_large?: string;
    small?: string;
    medium?: string;
    large?: string;
    original?: string;
  };
  videos?: {
    thumbnail_small?: string;
    thumbnail_large?: string;
    small?: string;
    medium?: string;
    large?: string;
    original?: string;
  };
};

type Props = {
  userId?: string;
  size?: 'tiny' | 'small' | 'medium' | 'large';
  style?: ViewStyle;
  profile?: Profile;
  isLoading?: boolean;
};

const SIZE_MAP = {
  tiny: { styleSize: 36, imgSize: 'thumbnail_small' as const },
  small: { styleSize: 75, imgSize: 'small' as const },
  medium: { styleSize: 225, imgSize: 'medium' as const },
  large: { styleSize: 300, imgSize: 'large' as const },
};

export function Avatar({
  userId,
  size = 'small',
  style,
  profile,
  isLoading,
}: Props) {
  const { styleSize, imgSize } = SIZE_MAP[size];

  return (
    <ProfileImg
      userId={userId}
      imgSize={imgSize}
      styleSize={styleSize}
      style={style}
      profile={profile}
      isLoading={isLoading}
    />
  );
}
